
// eslint-disable-next-line import/prefer-default-export
export const makeResponse = (response) => ({
  data: response.data,
  status: response.status,
  headers: response.headers,
});
